export const modalOwnerOptions = [
    {
        id: 1,
        name: 'Bri Massie',
        imageUrl: 'https://app.atharo.app/images/brimassie.jpg',
        value: 'Bri'
    },
    {
        id: 2,
        name: 'Courtney Malloy',
        imageUrl: 'https://app.atharo.app/images/courtneymalloy.jpg',
        value: 'Courtney'
    },
    {
        id: 3,
        name: 'Prescott Blackler',
        imageUrl: 'https://app.atharo.app/images/prescottblackler.jpg',
        value: 'Prescott'
    },
]

export const modalSchoolOptions = [
    {
        id: 1,
        name: 'Mountainside',
        imageUrl: 'https://app.atharo.app/mmalogo.png',
        value: 'mma'
    },
    {
        id: 2,
        name: 'Lakeside',
        imageUrl: 'https://app.atharo.app/lakesidelogo.png',
        value: 'lsma'
    },
    {
        id: 3,
        name: 'Treeside',
        imageUrl: 'https://app.atharo.app/treesidelogo.png',
        value: 'tma'
    },
    {
        id: 4,
        name: 'Morningside',
        imageUrl: 'https://app.atharo.app/morningsidelogo.png',
        value: 'mor'
    },
    {
        id: 5,
        name: 'Parkside',
        imageUrl: 'https://app.atharo.app/parksidelogo.png',
        value: 'psma'
    },
    {
        id: 6,
        name: 'Tempe',
        imageUrl: 'https://www.atharomusic.com/tempe-logo__dark.png',
        value: 'tem'
    },
    {
        id: 7,
        name: 'Denton',
        imageUrl: 'https://www.atharomusic.com/denton-logo__dark.png',
        value: 'den'
    },
    {
        id: 8,
        name: 'Tulsa',
        imageUrl: 'https://www.atharomusic.com/tulsa-logo__dark.png',
        value: 'tul'
    }
]